import { KeysZones, KeysNotInZone } from '@hid/define/define_zones'
import { GetDevicesDefineKeys } from '../../define/define_fn';
import { deviceManager } from '../../device/device_manager';

export const handleDefineKeys = async () => {
  return Object.fromEntries(GetDevicesDefineKeys(deviceManager.deviceID))
}

export const handleGetKeyZones = async () => {
  return {
    Data: KeysZones(),
    Filter: KeysNotInZone,
  }
}
